import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { apiGet } from '../utils/api'

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null)
  const token = localStorage.getItem('token')

  useEffect(() => {
    const checkAuth = async () => {
      if (!token) {
        setIsAuthenticated(false)
        return
      }

      try {
        // Проверяем валидность токена через проверку профиля
        await apiGet('/auth/profile')
        setIsAuthenticated(true)
      } catch (error) {
        // Токен невалиден или истек
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        setIsAuthenticated(false)
      }
    }

    checkAuth()
  }, [token])

  // Показываем загрузку пока проверяем токен
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-gray-600">Проверка авторизации...</div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

export default ProtectedRoute


